import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormGroup, Label, Form } from "reactstrap";
import { Select } from "semantic-ui-react";
import moment from "moment-timezone";
import { change_var_filter } from "../../config/redux/action";
import { isBiro } from "../../utils/helper";

const FormFilter = ({ label, description, type, value, title }) => {
  const currentYear = new Date().getFullYear();
  const dispatch = useDispatch();
  const onChange = (e) => { };
  const [rerender, setrerender] = useState(false);
  const [listBumd, setListBumd] = useState([

    {
      color: "#629DFF",
      value: "00ed7c5c-b0db-4ec3-8639-551603409a79",
      text: "PT Agro Jabar"
    },
    {
      color: "#CD6328",
      value: "c3d07e15-9dcc-4040-b351-bdd1f453589a",
      text: "PT Agronesia"
    },
    {
      color: "#315DA7",
      value: "8085cf6b-aabd-47b5-913b-2b17badb1e7a",
      text: "PT BIJB"
    },

    {
      color: "#EC884E",
      value: "32097ed8-a2cf-4005-ae40-abecbe7f1905",
      text: "PT Jasa Sarana"
    },
    {
      color: "#81CB51",
      value: "6ce17135-34b5-4649-b2cb-648984c71ab4",
      text: "PT Jaswita"
    },
    {
      color: "#F9BA26",
      value: "9006721b-b0ac-4d18-85dc-e51f51319ae3",
      text: "PT Migas Hilir Jabar"
    },
    {
      color: "#F05EE2",
      value: "1083ade1-980a-4ed0-b99b-3505bf08bee1",
      text: "PT Migas Utama Jabar"
    },
    {
      color: "#C7BDBD",
      value: "77b8bea9-310e-4a56-93b9-0d5e386d2761",
      text: "PT Tirta Gemah Ripah"
    },
    {
      color: "#FF8DAD",
      value: "456cba84-20f0-4f80-91c9-29d33b5d436e",
      text: "PDAP"
    }
  ]);
  const [listJenisLaporan, setListJenisLaporan] = useState([
    { value: "laporan_tahunan", text: "Laporan Tahunan" },
    { value: "laporan_bulanan", text: "Laporan Bulanan" },
    // { value: "laporan_triwulan", text: "Laporan Triwulan" },
    // { value: "laporan_smester", text: "Laporan Semester" },
    // { value: "laporan_rkap", text: "RKAP" }
  ]);
  const [selectedJenisLaporan, setSelectedJenisLaporan] = useState("");
  const [listTahun, setListTahun] = useState([
    {
      value: 2012,
      startMonth: 0,
      endMonth: 0,
      text: "2012"
    },
    {
      value: moment().format("YYYY") - 10,
      startMonth: 0,
      endMonth: 0,
      text: currentYear - 10
    },
    {
      value: moment().format("YYYY") - 9,
      startMonth: 0,
      endMonth: 0,
      text: currentYear - 9
    },
    {
      value: moment().format("YYYY") - 8,
      startMonth: 0,
      endMonth: 0,
      text: currentYear - 8
    },
    {
      value: moment().format("YYYY") - 7,
      startMonth: 0,
      endMonth: 0,
      text: currentYear - 7
    },
    {
      value: moment().format("YYYY") - 6,
      startMonth: 0,
      endMonth: 0,
      text: currentYear - 6
    },
    {
      value: moment().format("YYYY") - 5,
      startMonth: 0,
      endMonth: 0,
      text: currentYear - 5
    },
    {
      value: moment().format("YYYY") - 4,
      startMonth: 0,
      endMonth: 0,
      text: currentYear - 4
    },
    {
      value: moment().format("YYYY") - 3,
      startMonth: 0,
      endMonth: 0,
      text: currentYear - 3
    },
    {
      value: moment().format("YYYY") - 2,
      startMonth: 0,
      endMonth: 0,
      text: currentYear - 2
    },
    {
      value: moment().format("YYYY") - 1,
      startMonth: 0,
      endMonth: 0,
      text: currentYear - 1
    },
    {
      value: moment().format("YYYY"),
      startMonth: 0,
      endMonth: 0,
      text: currentYear
    },
  ]);

  const listDataFilter = [
    [
      {
        value: 2012,
        startMonth: 0,
        endMonth: 0,
        text: "2012"
      },
      {
        value: moment().format("YYYY") - 10,
        startMonth: 0,
        endMonth: 0,
        text: currentYear - 10
      },
      {
        value: moment().format("YYYY") - 9,
        startMonth: 0,
        endMonth: 0,
        text: currentYear - 9
      },
      {
        value: moment().format("YYYY") - 8,
        startMonth: 0,
        endMonth: 0,
        text: currentYear - 8
      },
      {
        value: moment().format("YYYY") - 7,
        startMonth: 0,
        endMonth: 0,
        text: currentYear - 7
      },
      {
        value: moment().format("YYYY") - 6,
        startMonth: 0,
        endMonth: 0,
        text: currentYear - 6
      },
      {
        value: moment().format("YYYY") - 5,
        startMonth: 0,
        endMonth: 0,
        text: currentYear - 5
      },
      {
        value: moment().format("YYYY") - 4,
        startMonth: 0,
        endMonth: 0,
        text: currentYear - 4
      },
      {
        value: moment().format("YYYY") - 3,
        startMonth: 0,
        endMonth: 0,
        text: currentYear - 3
      },
      {
        value: moment().format("YYYY") - 2,
        startMonth: 0,
        endMonth: 0,
        text: currentYear - 2
      },
      {
        value: moment().format("YYYY") - 1,
        startMonth: 0,
        endMonth: 0,
        text: currentYear - 1
      },
      {
        value: moment().format("YYYY"),
        startMonth: 0,
        endMonth: 0,
        text: currentYear
      },

    ],
    [
      { value: 1, startMonth: 1, endMonth: 1, text: "Januari" },
      { value: 2, startMonth: 2, endMonth: 2, text: "Februari" },
      { value: 3, startMonth: 3, endMonth: 3, text: "Maret" },
      { value: 4, startMonth: 4, endMonth: 4, text: "April" },
      { value: 5, startMonth: 5, endMonth: 5, text: "Mei" },
      { value: 6, startMonth: 6, endMonth: 6, text: "Juni" },
      { value: 7, startMonth: 7, endMonth: 7, text: "Juli" },
      { value: 8, startMonth: 8, endMonth: 8, text: "Agustus" },
      { value: 9, startMonth: 9, endMonth: 9, text: "September" },
      { value: 10, startMonth: 10, endMonth: 10, text: "Oktober" },
      { value: 11, startMonth: 11, endMonth: 11, text: "November" },
      { value: 12, startMonth: 12, endMonth: 12, text: "Desember" }
    ],
    [
      { value: "1-3", startMonth: 1, endMonth: 3, text: "Q1" },
      { value: "4-6", startMonth: 4, endMonth: 6, text: "Q2" },
      { value: "7-9", startMonth: 7, endMonth: 9, text: "Q3" },
      { value: "10-12", startMonth: 10, endMonth: 12, text: "Q4" }
    ],
    [
      { value: "1-6", startMonth: 1, endMonth: 6, text: "Semester 1" },
      { value: "7-12", startMonth: 7, endMonth: 12, text: "Semester 2" }
    ],
    [
      {
        value: moment().format("YYYY") - 1,
        startMonth: 0,
        endMonth: 0,
        text: moment().format("YYYY") - 1
      },
      {
        value: moment().format("YYYY") - 2,
        startMonth: 0,
        endMonth: 0,
        text: moment().format("YYYY") - 2
      }
    ]
  ];
  const [listPeriode, setListPeriode] = useState([]);
  useEffect(() => {
    setrerender(true);
    setListPeriode([]);
    if (selectedJenisLaporan) {
      var index = 0;
      if (selectedJenisLaporan == "laporan_tahunan") index = 0;
      if (selectedJenisLaporan == "laporan_bulanan") index = 1;
      // if (selectedJenisLaporan == "laporan_triwulan") index = 2;
      // if (selectedJenisLaporan == "laporan_smester") index = 3;
      // if (selectedJenisLaporan == "laporan_rkap") index = 4;

      setListPeriode(listDataFilter[index]);
      setTimeout(() => {
        setrerender(false);
      }, 100);
    }
    setTimeout(() => {
      setrerender(false);
    }, 100);
  }, [selectedJenisLaporan]);

  return (
    <>

      <div className="card border-0 rounded-0">
        <div className="container py-4">
          <div className="row px-4">
            <div className="col-md-4 d-flex align-items-center ">
              <h3 className="mr-auto my-auto">{title}</h3>
            </div>
            <div className="col-md-12">
              <div className="row">
                <div className="col d-flex justify-content-start align-items-center mt-md-0 mt-3">

                  {isBiro() && (
                    <div className="mr-3">
                      <FormGroup className="mr-md-2">
                        <Label className="mr-3">Perusahaan</Label>
                        <br />
                        <Select
                          placeholder="BUMD"
                          options={listBumd}
                          onChange={(e, { value }) => {
                            var type = "";
                            var bumd = "";
                            if (value == 0) {
                              bumd = "";
                              dispatch(change_var_filter({ prop: "bumd", value: "" }));
                            } else {
                              bumd = value;
                              dispatch(change_var_filter({ prop: "bumd", value: bumd }));
                            }
                          }}
                        />
                      </FormGroup>
                    </div>
                  )}
                  <div>
                    <FormGroup className="mr-md-2">
                      <Label className="mr-3">Jenis Laporan</Label>
                      <br />
                      <Select
                        placeholder="laporan Tahunan"
                        options={listJenisLaporan}
                        onChange={(e, { value }) => {
                          setSelectedJenisLaporan(value);
                          dispatch(change_var_filter({ prop: "jenis", value }));
                          dispatch(change_var_filter({ prop: "periode", value }));
                          dispatch(change_var_filter({ prop: "endYear", value: currentYear }));
                        }}
                      />
                    </FormGroup>
                  </div>
                  <div>
                    <FormGroup className="mr-md-2">
                      <Label className="mr-3"> {selectedJenisLaporan !== "laporan_tahunan" ? "Periode" : "From"}</Label>
                      <br />
                      <Select
                        placeholder="5 Tahun terakhir"
                        options={listPeriode}
                        onChange={(e, { value }) => {
                          if (selectedJenisLaporan == "laporan_bulanan") {
                            dispatch(
                              change_var_filter({ prop: "periode", value })
                            );
                            dispatch(
                              change_var_filter({ prop: "endYear", value: currentYear })
                            );
                            dispatch(
                              change_var_filter({ prop: "startYear", value: currentYear })
                            );
                            dispatch(change_var_filter({ prop: "startMonth", value }));
                            dispatch(change_var_filter({ prop: "endMonth", value }));
                          } else if (
                            selectedJenisLaporan == "laporan_tahunan"
                          ) {
                            dispatch(
                              change_var_filter({ prop: "periode", value })
                            );
                            dispatch(
                              change_var_filter({ prop: "startYear", value: value })
                            );
                            // dispatch(
                            //   change_var_filter({ prop: "endYear", value: currentYear })
                            // );
                            dispatch(
                              change_var_filter({
                                prop: "startMonth",
                                value: 0
                              })
                            );
                            dispatch(
                              change_var_filter({
                                prop: "endMonth",
                                value: 0
                              })
                            );
                          } else if (
                            selectedJenisLaporan == "laporan_triwulan"
                          ) {
                            var arr = value.split("-");
                            dispatch(
                              change_var_filter({ prop: "periode", value })
                            );
                            // dispatch(
                            //   change_var_filter({ prop: "startYear", value: currentYear })
                            // );
                            // dispatch(
                            //   change_var_filter({ prop: "endYear", value: currentYear })
                            // );
                            dispatch(
                              change_var_filter({
                                prop: "startMonth",
                                value: parseInt(arr[0])
                              })
                            );
                            dispatch(
                              change_var_filter({
                                prop: "endMonth",
                                value: parseInt(arr[1])
                              })
                            );
                          } else {
                            var arr = value.split("-");
                            dispatch(
                              change_var_filter({ prop: "periode", value })
                            );
                            // dispatch(
                            //   change_var_filter({ prop: "startYear", value: currentYear })
                            // );
                            // dispatch(
                            //   change_var_filter({ prop: "endYear", value: currentYear })
                            // );
                            dispatch(
                              change_var_filter({
                                prop: "startMonth",
                                value: parseInt(arr[0])
                              })
                            );
                            dispatch(
                              change_var_filter({
                                prop: "endMonth",
                                value: parseInt(arr[1])
                              })
                            );
                          }
                        }}
                      />
                    </FormGroup>
                  </div>
                  <div>

                    <FormGroup className="mr-md-2">
                      <Label className="mr-3"> {selectedJenisLaporan !== "laporan_tahunan" ? "Tahun" : "To"} </Label>
                      <br />
                      {selectedJenisLaporan !== "laporan_tahunan" ? (
                        <Select
                          options={listTahun}
                          onChange={(e, { value }) => {
                            var tahun = "";

                            tahun = value;
                            dispatch(
                              change_var_filter({ prop: "startYear", value: tahun })
                            );
                            dispatch(
                              change_var_filter({ prop: "endYear", value: tahun })
                            );
                          }}
                        />
                      ) : (
                        <Select
                          options={listTahun}
                          onChange={(e, { value }) => {
                            var tahun = "";

                            tahun = value;
                            dispatch(
                              change_var_filter({ prop: "endYear", value: tahun })
                            );
                          }}
                        />

                      )}
                    </FormGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default FormFilter;